
export interface BoxxOAuthResponseProps {
  authResponse: any;
  profileResponse: any;
  pages?: any;
}
